export default __webpack_public_path__ + "static/media/GR00037-mentor_amulet_6.96cfdfa2.svg";